import { render, staticRenderFns } from "./RubricaFormAll.vue?vue&type=template&id=c6a4a882&scoped=true&"
import script from "./RubricaFormAll.vue?vue&type=script&lang=js&"
export * from "./RubricaFormAll.vue?vue&type=script&lang=js&"
import style0 from "./RubricaFormAll.vue?vue&type=style&index=0&id=c6a4a882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a4a882",
  null
  
)

export default component.exports